/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";

const PresetsIcon = ({ isActive, className }) => {
  const fill = isActive ? "#FFFFFF" : "#9A9A9A";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 18 18"
      className={classNames(className)}
      fill="none"
      test-id="wguxH_2W"
    >
      <path
        d="M3 15.75C2.5875 15.75 2.23438 15.6031 1.94063 15.3094C1.64688 15.0156 1.5 14.6625 1.5 14.25V3.75C1.5 3.3375 1.64688 2.98438 1.94063 2.69063C2.23438 2.39688 2.5875 2.25 3 2.25H3.75V0.75H5.25V2.25H11.25V0.75H12.75V2.25H13.5C13.9125 2.25 14.2656 2.39688 14.5594 2.69063C14.8531 2.98438 15 3.3375 15 3.75V6.75H3V14.25H6.75V15.75H3ZM3 5.25H13.5V3.75H3V5.25Z"
        fill={fill}
        test-id="TrFZO3vn"
      />
      <path
        d="M11.8687 16.5L11.6437 15.375C11.4937 15.3125 11.3531 15.2438 11.2219 15.1688C11.0906 15.0938 10.9625 15.0063 10.8375 14.9062L9.75 15.2812L9 13.9875L9.84375 13.2375C9.81875 13.05 9.80625 12.8906 9.80625 12.7594C9.80625 12.6281 9.81875 12.4688 9.84375 12.2812L9 11.5312L9.75 10.2375L10.8375 10.6125C10.9625 10.5125 11.0906 10.4219 11.2219 10.3406C11.3531 10.2594 11.4937 10.1875 11.6437 10.125L11.8687 9H13.3687L13.5938 10.125C13.7437 10.1875 13.8844 10.2563 14.0156 10.3313C14.1469 10.4062 14.275 10.4937 14.4 10.5938L15.4875 10.2188L16.2375 11.5125L15.3938 12.2625C15.4188 12.45 15.4313 12.6094 15.4313 12.7406C15.4313 12.8719 15.4188 13.0312 15.3938 13.2188L16.2375 13.9688L15.4875 15.2625L14.4 14.9062C14.275 15.0063 14.1469 15.0938 14.0156 15.1688C13.8844 15.2438 13.7437 15.3125 13.5938 15.375L13.3687 16.5H11.8687ZM12.6187 14.25C13.0312 14.25 13.3844 14.1031 13.6781 13.8094C13.9719 13.5156 14.1188 13.1625 14.1188 12.75C14.1188 12.3375 13.9719 11.9844 13.6781 11.6906C13.3844 11.3969 13.0312 11.25 12.6187 11.25C12.2063 11.25 11.8531 11.3969 11.5594 11.6906C11.2656 11.9844 11.1187 12.3375 11.1187 12.75C11.1187 13.1625 11.2656 13.5156 11.5594 13.8094C11.8531 14.1031 12.2063 14.25 12.6187 14.25Z"
        fill={fill}
        test-id="If0e9OO7"
      />
    </svg>
  );
};

export default PresetsIcon;
